import { InjectionToken, Injector } from '@angular/core';

export interface EventModalDetailsContext {
    isEnabled: boolean;
    injector: Injector | undefined;
}

export const EVENT_DETAILS_MODAL_CONTEXT = new InjectionToken<EventModalDetailsContext>('EVENT_DETAILS_MODAL_CONTEXT', {
    factory: () => ({
        isEnabled: false,
        injector: undefined,
    }),
    providedIn: 'root',
});
